<template>
    <div>
        <v-card flat>
            <v-card-title>
                <span class="text-h5"
                    >Transferir Stock: {{ reference }}
                    {{ originLabel ? `Origen: ${originLabel}` : "" }}</span
                >
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="2" sm="2" md="2" class="pb-0">
                            <v-text-field
                                v-model="reference"
                                label="Referencia"
                                outlined
                                class="mb-3"
                                :disabled="disableRef"
                            ></v-text-field>
                        </v-col>

                        <v-col cols="2" sm="2" md="2" class="pb-0">
                            <v-autocomplete
                                v-model="zoneOrigin"
                                :items="itemsZones"
                                label="Zona Origen"
                                outlined
                                auto-select-first
                                :disabled="disableRef"
                            ></v-autocomplete>
                        </v-col>

                        <v-col cols="2" sm="2" md="2" class="pb-0">
                            <v-autocomplete
                                v-model="zoneDestination"
                                :items="itemsZonesFiltred"
                                label="Zona Destino"
                                outlined
                                auto-select-first
                                :disabled="disableRef"
                            ></v-autocomplete>
                        </v-col>

                        <v-col cols="3" sm="3" md="3" class="pb-0">
                            <v-autocomplete
                                v-model="product"
                                :items="itemsByZone"
                                label="Codigo Producto"
                                auto-select-first
                                outlined
                                ref="cod"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="2" sm="2" md="2" class="pb-0">
                            <v-text-field
                                v-model="quantity"
                                label="Cantidad"
                                outlined
                                required
                                type="number"
                            ></v-text-field>
                        </v-col>

                        <v-col cols="1" sm="1" md="1">
                            <v-icon
                                color="success"
                                @click="onList"
                                v-text="'mdi-check-outline'"
                                :disabled="!isNewItemOk"
                            ></v-icon>
                            -
                        </v-col>
                    </v-row>

                    <v-data-table
                        :headers="headers"
                        :items="productsAggregate"
                        class="elevation-1 custom-font"
                    >
                        <template v-slot:[`item.actions`]="{ item }">
                            <v-icon small @click="deleteItem(item)">
                                mdi-delete
                            </v-icon>
                        </template>
                    </v-data-table>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-alert shaped dense dark type="warning" v-if="info !== ''">
                    {{ info }}
                </v-alert>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="cancelStock">
                    Cancelar
                </v-btn>
                <v-btn
                    :disabled="!isOk"
                    color="blue darken-1"
                    text
                    @click="saveStock"
                >
                    Guardar
                </v-btn>
            </v-card-actions>
        </v-card>
    </div>
</template>
<script>
import { getInventoryZonesItems } from "../../dataApi";
export default {
    name: "transfer-stock",
    props: {
        products: {
            type: Array,
            default: () => [],
        },
        providers: {
            type: Array,
            default: () => [],
        },
    },
    data: () => ({
        selectedRef: null,
        product: 0,
        quantity: 0,
        provider: null,
        reference: `Mov-${Date.now().toString().slice(-7)}`,
        itemsProducts: [],
        itemsProviders: [],
        productsAggregate: [],
        disableRef: false,
        originLabel: null,
        headers: [
            { text: "Cantidad", value: "quantity" },
            { text: "Producto", value: "description" },
            { text: "Zona Origen", value: "zoneOriginText" },
            { text: "Zona Destino", value: "zoneDestinationText" },
            { text: "Acciones", value: "actions", sortable: false },
        ],
        itemsZones: [],
        zoneOrigin: null,
        zoneDestination: null,
    }),
    mounted() {
        console.log(this.products, this.providers);
    },
    methods: {
        async createdValuesItems() {
            this.itemsZones = await getInventoryZonesItems();
        },

        async onList() {
            const quantity = parseInt(this.quantity);
            const product = this.itemsByZone.find(
                (product) => product.value === this.product,
            );
            const exist = this.productsAggregate.findIndex(
                (product) => product.id === this.product,
            );
            if (exist !== -1) {
                this.productsAggregate[exist].quantity += quantity;
            } else {
                this.productsAggregate.push({
                    id: this.product,
                    description: product.text,
                    quantity,
                    zoneOrigin: this.zoneOrigin,
                    zoneDestination: this.zoneDestination,
                    reference: this.reference,
                    zoneOriginText: this.itemsZones.find(
                        (zone) => zone.value === this.zoneOrigin,
                    )?.text,
                    zoneDestinationText: this.itemsZones.find(
                        (zone) => zone.value === this.zoneDestination,
                    )?.text,
                });
            }
            this.quantity = 0;
            this.product = 0;
            this.disableRef = true;
            if (!this.originLabel) {
                const origin = this.itemsProviders.find(
                    (provider) => provider.value === this.provider,
                );
                if (origin) this.originLabel = origin.text;
            }
        },
        deleteItem(item) {
            const index = this.productsAggregate.findIndex(
                (product) => product.id === item.id,
            );
            if (index !== -1) {
                this.productsAggregate.splice(index, 1);
            }
        },
        onEdit() {
            this.disableRef = false;
            this.originLabel = null;
        },
        cancelStock() {
            this.$emit("cancelStock", {});
        },
        saveStock() {
            this.$emit("executeTransferStock", this.productsAggregate);
        },
    },

    mounted() {
        this.createdValuesItems();
    },

    computed: {
        isNewItemOk() {
            return (
                this.product !== 0 &&
                parseInt(this.quantity) !== 0 &&
                this.reference != "" &&
                this.zoneOrigin !== null &&
                this.zoneDestination !== null &&
                parseInt(this.quantity) <= this.quantityMax
            );
        },

        isOk() {
            return (
                this.productsAggregate.length > 0 &&
                this.zoneOrigin !== null &&
                this.zoneDestination !== null &&
                this.reference != ""
            );
        },

        itemsByZone() {
            const itemsProduct = [];
            if (this.zoneOrigin) {
                this.products.forEach((product) => {
                    const inventory = product.inventory.find(
                        (inventory) => inventory.zoneId === this.zoneOrigin,
                    );
                    if (
                        inventory &&
                        inventory.quantity - inventory.quantityLock > 0
                    ) {
                        const productOut = this.productsAggregate.find(
                            (productPreSelect) =>
                                productPreSelect.id === product.id,
                        );
                        if (!productOut) {
                            itemsProduct.push({
                                text: `${product.name} - ${product.description}`,
                                value: product.id,
                                quantity:
                                    inventory.quantity - inventory.quantityLock,
                            });
                        }
                    }
                });
            }
            return itemsProduct;
        },
        info() {
            let info =
                "Solo se mostraran los productos con stock disponible en la zona de origen";
            if (this.product) {
                const product = this.itemsByZone.find(
                    (product) => product.value === this.product,
                );
                if (product) {
                    info = `${product.text}:Disponible: ${product.quantity}`;
                }
            }
            return info;
        },
        quantityMax() {
            let max = 0;
            if (this.product) {
                const product = this.itemsByZone.find(
                    (product) => product.value === this.product,
                );
                if (product) {
                    max = product.quantity;
                }
            }
            return max;
        },

        itemsZonesFiltred() {
            return this.itemsZones.filter(
                (zone) => zone.value !== this.zoneOrigin,
            );
        },
    },
};
</script>
